import {
  REPORT_CUSTOM_FILTER_UPDATE,
  REPORT_CUSTOM_FILTER_CLEAR,
} from '../actions/types/ReportActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

const initialState = {
  allOrigin: false,
  allDestination: false,
  showSending: false,
  showReceiving: true,
  showMailBoxes: false,
  mrdLikeStatus: false,
  excludeEtoes: true,
  referencePeriod: {
    startDate: '',
    endDate: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REPORT_CUSTOM_FILTER_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    case REPORT_CUSTOM_FILTER_CLEAR:
      return initialState;
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
